module.exports = __webpack_public_path__ + "static/media/es.cc1b41b0.svg";